<div class="building-scan-viewer noselect">
  <wr-scan-viewer [scan]="scan" [readonly]="readonly"></wr-scan-viewer>
</div>
<div class="building-scan-list">
  <wr-building-scan-poi-navigator [scanId]="scan.id" [readonly]="readonly"></wr-building-scan-poi-navigator>
</div>
